export function getResourceFilter() {
  return {
    EnableTimeCards: true,
  };
}
